import { create } from 'zustand'
import { CentroCustoResume } from '../../types/comercial/centroCusto'
import { comercialAPI } from '../../api'

interface CentroCustoState {
  centroCustoResume: CentroCustoResume[]
  setCentroCustoResume: () => Promise<void>
  erroCentroCustoResume: boolean
  loadingCentroCustoResume: boolean
  setErroCentroCustoResume: (erro: boolean) => void
  cleanCentroCustoState: () => void
}

export const useCentroCustoStore = create<CentroCustoState>((set) => ({
  centroCustoResume: [],
  erroCentroCustoResume: false,
  loadingCentroCustoResume: false,
  setCentroCustoResume: async () => {
    set(() => ({ loadingCentroCustoResume: true, erroCentroCustoResume: false }))
    const result = await comercialAPI.getCentrosResume()
    if (result.statusCode == 200 && result.data) {
      set(() => ({ centroCustoResume: result.data }))
    }
    else {
      set(() => ({ erroCentroCustoResume: true, centroCustoResume: [] }))
    }
    set(() => ({ loadingCentroCustoResume: false }))
  },
  setErroCentroCustoResume: (erro: boolean) => {
    set(() => ({ erroCentroCustoResume: erro }))
  },
  cleanCentroCustoState: () => {
    set(() => ({ centroCustoResume: [], erroCentroCustoResume: false, loadingCentroCustoResume: false }))
  }
}))